import { tv } from "tailwind-variants";

export const getButtonClass = tv({
  base: "inline-flex w-fit items-center justify-center whitespace-nowrap rounded-[50px] font-semibold text-sm ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  variants: {
    variant: {
      primary: "bg-primary text-primary-foreground hover:bg-primary/90",
      cta: "bg-cta-500 text-white hover:bg-cta-500/85",
      outline: "border border-[#003376] text-[#003376] hover:bg-[#003376]/5",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline",
    },
    size: {
      default: "h-10 px-4 py-2",
      sm: "h-9 px-3",
      lg: "h-11 px-6 text-base",
      xl: "h-13 px-8 text-base",
      icon: "size-10",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "default",
  },
});
